const Snackbar = {
  FAILED_APOSTILLE: 'アポスティーユの作成に失敗しました',
  INVALID_ADDRESS: 'アドレスが正しくありません',
  DEPLICATE_ADDRESS: 'アドレスが重複しています',
  FAILED_READ_QRKEY: 'QRキーが読み込めませんでした',
  DEPLICATE_METADATA: 'メタデータのキーが重複しています',
  INVALID_METADATA: 'メタデータの値を設定してください',
  SUCCESS_COSIGN: '署名しました',
  FAILED_COSIGN: '署名に失敗しました',
};

export default Snackbar;
